<template>
  <div class="rtf-preview">
    <div style="color: #057ee5; cursor: pointer" @click="$router.go(-1)">
      <i class="el-icon-arrow-left"></i>
      <span> 返回列表</span>
    </div>
    <!-- <div class="rtf-preview-top">
      <div class="rtf-preview-top-title" v-html="rtfPreviewData.title"></div>
      <div v-if="rtfPreviewData.createTime" class="rtf-preview-top-sub-title">
        <span>发布日期：{{ rtfPreviewData.createTime }}</span>
        <span> 来源：{{ rtfPreviewData.source }}</span>
      </div>
    </div> -->
    <!-- <div v-html="rtfPreviewData.content" class="rtfPreview-content" /> -->
    <div
      v-html="rtfPreviewData.content"
      class="rtfPreview-content"
      v-if="rtfPreviewData.content && !url"
    ></div>
    <div v-if="url">
      <pdf v-for="i in numPages" :key="i" :src="url" :page="i"></pdf>
    </div>
  </div>
</template>

<script>
/**
 * @Author LuoYang
 * @Email toluoyang@qq.com
 * @Date 2022/7/13 15:36
 * @Description 富文本查看
 */
import pdf from "vue-pdf";
export default {
  name: "rtfPreview",
  components: {
    pdf,
  },
  data() {
    return {
      rtfPreviewData: undefined,
      url: "",
      numPages: 0,
    };
  },
  created() {
    this.rtfPreviewData = JSON.parse(sessionStorage.getItem(this.$route.name));
  },
  mounted() {
    this.updated();
    if (this.rtfPreviewData.pronounceFiles) {
      this.url =
        systemConfig.imgServer +
        systemConfig.imgApi +
        this.rtfPreviewData.pronounceFiles[0].filePath;
      var loadingTask = pdf.createLoadingTask(this.url);
      loadingTask.promise.then((pdf) => {
        this.url = loadingTask;
        this.numPages = pdf.numPages;
      });
    }
  },
  methods: {
    updated() {
      this.$nextTick(() => {
        let app = document.getElementById("app");
        app.scrollTop = 0;
      });
    },
  },
};
</script>

<style scoped>
.rtf-preview {
  width: 60%;
  min-height: calc(100% - 60px);
  padding: 10px 60px;
  background-color: #f6f6f6;
  margin: 0 auto;
  box-sizing: border-box;
  display: inline-table;
}

.rtf-preview-top {
  display: flex;
  align-items: center;
  border-bottom: solid 1px #dadada;
  flex-direction: column;
  padding-bottom: 10px;
}

.rtf-preview-top-title {
  font-size: 1.25rem;
  font-weight: bold;
  flex-shrink: 0;
  text-align: center;
}

.rtf-preview-top-sub-title {
  font-size: 0.75rem;
  margin-top: 10px;
  color: #919191;
}

.rtfPreview-content {
  margin-top: 10px;
}
</style>
